import { BrowserRouter, Routes, Route } from "react-router-dom";
import Containers from "./containers";

const Routing = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path={"/:firstParam/:secondParam/:thirdParam/:fourthParam"} element={<Containers />} />
                <Route path={"/:firstParam/:secondParam/:thirdParam"} element={<Containers />} />
                <Route path={"/:firstParam/:secondParam"} element={<Containers />} />
                <Route path={"/:firstParam"} element={<Containers />} />
                <Route path={"/"} element={<Containers />} />
            </Routes>
        </BrowserRouter>
    );
};

export default Routing;
